module.exports = __webpack_public_path__ + "img/bx-8.1fe3f767.jpg";